import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  btag,
  constants,
  pushToDataLayer,
  sessionId,
  SessionStorageManager,
  SiteConfigManager,
  StorageManager,
  useDetection,
} from '@atlas/core';
import { CmdLink, signInRoutes, staticRoutes } from '@atlas/routing';
import { Label } from '@atlas/ui';

import { CXFROM_STORAGE_KEY, DATA_LAYER_STORAGE_KEYS } from 'common/constants';
import { useSignupPopup } from 'src/components/SignUp/useSignUpPopup';

const { phone } = signInRoutes;
const { signup } = staticRoutes;

const HeaderInfoUnauthorized = ({ customSignUpBtnCallback, isTerminal }) => {
  const { openSignupPopup } = useSignupPopup();
  const { browser, ip, locale, os } = useDetection();
  const { pathname } = useLocation();

  const handleSignInClick = () => {
    const pathToSave = pathname !== '/signup' ? pathname : null;
    if (pathToSave) {
      StorageManager.setItem(CXFROM_STORAGE_KEY, pathToSave);
    }
  };

  const isRegistrationButtonClicked = SessionStorageManager.getItem(
    DATA_LAYER_STORAGE_KEYS.REGISTRATION_BUTTON_CLICKED,
  );

  const sendRegistrationButtonClickEvent = () => {
    pushToDataLayer(
      'registration_button_click',
      {
        OS: os,
        browser,
        created_at: Date.now(),
        device: constants.DEVICE_TYPES.DESKTOP,
        ip,
        locale,
        page_referer: window.location.pathname,
        session_id: sessionId,
      },
      btag,
    );
    SessionStorageManager.setItem(DATA_LAYER_STORAGE_KEYS.REGISTRATION_BUTTON_CLICKED, true);
  };

  const openSignupPopupWithCallback = () => {
    if (customSignUpBtnCallback) {
      customSignUpBtnCallback();
    } else {
      openSignupPopup();
    }
    if (isRegistrationButtonClicked) return;
    sendRegistrationButtonClickEvent();
  };

  return (
    <>
      <div className="header-info__btn">
        <CmdLink
          className="header__signin btn secondary medium block"
          cmd="signin"
          onClick={handleSignInClick}
          path={phone}
          state={{ terminal_kyc_verification: isTerminal }}
        >
          <Label message="login" />
        </CmdLink>
      </div>

      {SiteConfigManager.getConfig('config.config.enable_registration') && (
        <div className="header-info__btn">
          {SiteConfigManager.getConfig('config.config.registration.showInPopup') ? (
            <button
              className="header__signup btn primary medium block"
              onClick={openSignupPopupWithCallback}
            >
              <Label message="sign up" />
            </button>
          ) : (
            <Link
              className="header__signup btn primary medium block"
              onClick={sendRegistrationButtonClickEvent}
              to={signup}
            >
              <Label message="sign up" />
            </Link>
          )}
        </div>
      )}
    </>
  );
};

HeaderInfoUnauthorized.propTypes = {
  customSignUpBtnCb: PropTypes.func,
  isTerminal: PropTypes.bool,
};

export default HeaderInfoUnauthorized;
